var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PacemEventTarget, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
//namespace Pacem.Components.Drawing3D {
export class Pacem3DPrimitiveElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (Utils.isNull(this.geometry)) {
            this.geometry = this.createDefaultGeometry();
        }
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Json })
], Pacem3DPrimitiveElement.prototype, "geometry", void 0);
